import dayjs from 'dayjs';

import { EBookingStatus } from 'types';

import { IBookingsResponse, IHostGroupsResponse } from './types';

export const HOSTS_MOCKED_RESPONSE: IHostGroupsResponse = {
  hostGroupsOverview: [
    {
      id: 3160,
      title: 'Common',
    },
    {
      id: 3161,
      title: 'Super Vip',
    },
    {
      id: 3164,
      title: 'Vip',
    },
  ],
  hostsOverview: [
    {
      id: 3528,
      alias: 'PC-1',
      position: 1,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3531,
      alias: 'PC-2',
      position: 2,
      group_id: 3161,
      client_sessions: [],
    },
    {
      id: 3536,
      alias: 'PC-3',
      position: 3,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3537,
      alias: 'PC-4',
      position: 4,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3549,
      alias: 'PC-5',
      position: 5,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3551,
      alias: 'PC-6',
      position: 6,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3540,
      alias: 'PC-7',
      position: 7,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3541,
      alias: 'PC-8',
      position: 8,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3542,
      alias: 'PC-9',
      position: 9,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3543,
      alias: 'PC-10',
      position: 10,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3544,
      alias: 'PC-11',
      position: 11,
      group_id: 3160,
      client_sessions: [],
    },
    {
      id: 3545,
      alias: 'PC-12',
      position: 12,
      group_id: 3164,
      client_sessions: [],
    },
    {
      id: 3546,
      alias: 'PC-13',
      position: 13,
      group_id: 3164,
      client_sessions: [],
    },
  ],
};

export const GET_BOOKINGS_MOCKED_RESPONSE = (): IBookingsResponse => ({
  getBookings: {
    data: [
      {
        id: 832,
        group: '288e4c16-ade6-4f2d-a4a6-60388f119967',
        byClient: false,
        hostIds: [3543, 3531],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Coruler',
          phone: '79542164842',
        },
        from: dayjs().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 833,
        group: '288e4c16-ade6-4f2d-a4a6-60388f119967',
        byClient: false,
        hostIds: [3543, 3531],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Myoveto',
          phone: '795421357851',
        },
        from: dayjs().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 829,
        group: 'bf909d92-7665-49cf-a177-cf04f89345a3',
        byClient: false,
        hostIds: [3549, 3551, 3540],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Hisinno',
          phone: '79531549678',
        },
        from: dayjs().add(-7, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(-4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 831,
        group: 'bf909d92-7665-49cf-a177-cf04f89345a3',
        byClient: false,
        hostIds: [3549, 3551, 3540],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Ianisto',
          phone: '79543215748',
        },
        from: dayjs().add(-7, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(-4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 830,
        group: 'bf909d92-7665-49cf-a177-cf04f89345a3',
        byClient: false,
        hostIds: [3549, 3551, 3540],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Ettemiv',
          phone: '795213459687',
        },
        from: dayjs().add(-7, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(-4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 826,
        group: '0c9e0501-af1c-4609-b464-6bce2cb40f9c',
        byClient: false,
        hostIds: [3545, 3546],
        client: undefined,
        from: dayjs().add(-5, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(-3, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 825,
        group: '0c9e0501-af1c-4609-b464-6bce2cb40f9c',
        byClient: false,
        hostIds: [3545, 3546],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Yanenis',
          phone: '795213547987',
        },
        from: dayjs().add(-5, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(-3, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 834,
        group: '7deb7f3d-a72b-4991-a5ff-7e9422fe7359',
        byClient: false,
        hostIds: [3540, 3549, 3544],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Keneano',
          phone: '7951324687',
        },
        from: dayjs().add(-2, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(2, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 835,
        group: '7deb7f3d-a72b-4991-a5ff-7e9422fe7359',
        byClient: false,
        hostIds: [3540, 3549, 3544],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Joatimb',
          phone: '79543215678',
        },
        from: dayjs().add(-2, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(2, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
      {
        id: 836,
        group: '7deb7f3d-a72b-4991-a5ff-7e9422fe7359',
        byClient: false,
        hostIds: [3540, 3549, 3544],
        client: {
          uuid: '873bdc87-a324-4e51-bffd-9f735e43b343',
          nickname: 'Zzelasa',
          phone: '7894651354878',
        },
        from: dayjs().add(-2, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs().add(2, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        status: EBookingStatus.ACTIVE,
      },
    ],
  },
});
